import { normalize, Schema, arrayOf } from 'normalizr';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { CALL_API } from 'redux-api-middleware';
import types from '../constants/actionTypes';
import Config from '../Config';
import { Map } from 'immutable';

const requestHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
});

export function fetchUsers() {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/users`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.USERS_REQUEST,
        {
          type: types.dataFetching.USERS_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {

              return res.json().then((json) => {
                const camelizedJson = camelizeKeys(json);
                return Object.assign({}, normalize(camelizedJson, arrayOf(user)));
              });
            }
          },
        },
        types.dataFetching.USERS_REQUEST_ERROR,
      ],
    },
  };
}

export function getCurrentUser() {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/users/get_current_user`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.CURRENT_USER_REQUEST,
        {
          type: types.dataFetching.CURRENT_USER_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) => {
                const camelizedJson = camelizeKeys(json);
                return Object.assign({}, normalize(camelizedJson, user));
              });
            }
          },
        },
        types.dataFetching.CURRENT_USER_ERROR,
      ],
    },
  };
}

function normalizeData(response, schema) {
  const contentType = response.headers.get('Content-Type');
  if (contentType && ~contentType.indexOf('json')) {

    return response.json().then((json) => {
      const camelizedJson = camelizeKeys(json);
      return Object.assign({}, normalize(camelizedJson, arrayOf(schema)));
    });
  }
}

export function fetchPolicies() {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/policies`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.POLICIES_REQUEST,
        {
          type: types.dataFetching.POLICIES_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.POLICIES_REQUEST_ERROR,
      ],
    },
  };
}

export function fetchMediaPlatforms() {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/media_platforms`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.MEDIA_PLATFORMS_REQUEST,
        {
          type: types.dataFetching.MEDIA_PLATFORMS_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.MEDIA_PLATFORMS_REQUEST_ERROR,
      ],
    },
  };
}

export function fetchFilterOptions() {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers/filter_options`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.FILTER_OPTIONS_REQUEST,
        {
          type: types.dataFetching.FILTER_OPTIONS_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.FILTER_OPTIONS_REQUEST_ERROR,
      ],
    },
  };
}

export function saveNewCollective(data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives`,
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys(data)),
      types: [
        types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST,
        {
          type: types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.SAVE_NEW_COLLECTIVE_REQUEST_ERROR,
      ],
    },
  };
}

// export function signOut() {
//   return dispatch => {
//     dispatch(requestLocationChange('login'));
//     dispatch(clearLocalSession());
//   };
//
//   return {
//     [CALL_API]: {
//       endpoint: `${Config.apiEndpoint}/users`,
//       method: 'DELETE',
//       headers: requestHeaders,
//       types: [
//         types.dataFetching.SIGN_OUT_REQUEST,
//         {
//           type: types.dataFetching.SIGN_OUT_REQUEST_SUCCESS,
//           payload: (action, state, res) => {
//             const contentType = res.headers.get('Content-Type');
//             if (contentType && ~contentType.indexOf('json')) {
//               return res.json().then((json) =>  camelizeKeys(json));
//             }
//           },
//         },
//         types.dataFetching.SIGN_OUT_REQUEST_ERROR,
//       ],
//     },
//   };
// }

export function saveNewInfluencer(data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers`,
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys(data)),
      types: [
        types.dataFetching.SAVE_NEW_INFLUENCER_REQUEST,
        {
          type: types.dataFetching.SAVE_NEW_INFLUENCER_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.SAVE_NEW_INFLUENCER_REQUEST_ERROR,
      ],
    },
  };
}

export function updateInfluencer(id, data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers/${id}`,
      method: 'PATCH',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys(data)),
      types: [
        types.dataFetching.UPDATE_INFLUENCER_REQUEST,
        {
          type: types.dataFetching.UPDATE_INFLUENCER_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.UPDATE_INFLUENCER_ERROR,
      ],
    },
  };
}

export function updateCollective(id, data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives/${id}`,
      method: 'PATCH',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys(data)),
      types: [
        types.dataFetching.UPDATE_COLLECTIVE_REQUEST,
        {
          type: types.dataFetching.UPDATE_COLLECTIVE_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.UPDATE_COLLECTIVE_ERROR,
      ],
    },
  };
}

export function removeInfluencer(id) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers/${id}`,
      method: 'DELETE',
      headers: requestHeaders,
      types: [
        types.dataFetching.REMOVE_INFLUENCER_REQUEST,
        {
          type: types.dataFetching.REMOVE_INFLUENCER_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.REMOVE_INFLUENCER_REQUEST_ERROR,
      ],
    },
  };
}

export function removeCollective(id) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives/${id}`,
      method: 'DELETE',
      headers: requestHeaders,
      types: [
        types.dataFetching.REMOVE_COLLECTIVE_REQUEST,
        {
          type: types.dataFetching.REMOVE_COLLECTIVE_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.REMOVE_COLLECTIVE_ERROR,
      ],
    },
  };
}

export function mergeCollective(oldCollectiveId, newCollectiveId) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives/${oldCollectiveId}/merge/${newCollectiveId}`,
      method: 'PATCH',
      headers: requestHeaders,
      types: [
        types.dataFetching.REMOVE_COLLECTIVE_REQUEST,
        {
          type: types.dataFetching.REMOVE_COLLECTIVE_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.REMOVE_COLLECTIVE_ERROR,
      ],
    },
  };
}

export function saveUser(data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/users/${data.id}`,
      method: 'PATCH',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys({ user: data })),
      types: [
        types.dataFetching.SAVE_USER_REQUEST,
        {
          type: types.dataFetching.SAVE_USER_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) => {
                const camelizedJson = camelizeKeys(json);
                return Object.assign({}, normalize(camelizedJson, user));
              });
            }
          },
        },
        types.dataFetching.SAVE_USER_REQUEST_ERROR,
      ],
    },
  };
}

export function fetchInitialData() {
  return (dispatch, getState) => {
    dispatch(fetchIndex(
      {
        REQUEST: types.dataFetching.FETCH_INITIAL_DATA_REQUEST,
        SUCCESS: types.dataFetching.FETCH_INITIAL_DATA_SUCCESS,
        ERROR: types.dataFetching.FETCH_INITIAL_DATA_ERROR,
      },
      'home',
    ));
  };
}

export function fetchIndex(actionTypes = {}, scope, queryParams = Map(), page) {
  // actionTypes required for each stage of request
  if (!actionTypes.REQUEST || !actionTypes.SUCCESS || !actionTypes.ERROR) return;

  const params = prepareParams(queryParams, page);

  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/${scope}${params}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        actionTypes.REQUEST,
        {
          type: actionTypes.SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        actionTypes.ERROR,
      ],
    },
  };
}

export function deleteUser(data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/users/${data.id}`,
      method: 'DELETE',
      headers: requestHeaders,
      types: [
        types.dataFetching.DELETE_USER_REQUEST,
        {
          type: types.dataFetching.DELETE_USER_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) => {
                const camelizedJson = camelizeKeys(json);
                return Object.assign({}, normalize(camelizedJson, user));
              });
            }
          },
        },
        types.dataFetching.DELETE_USER_ERROR,
      ],
    },
  };
}

export function createUser(data) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/users`,
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify(decamelizeKeys({ user: data })),
      types: [
        types.dataFetching.CREATE_USER_REQUEST,
        {
          type: types.dataFetching.CREATE_USER_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) => {
                const camelizedJson = camelizeKeys(json);
                return Object.assign({}, normalize(camelizedJson, user));
              });
            }
          },
        },
        types.dataFetching.CREATE_USER_ERROR,
      ],
    },
  };
}

export function loadInitialSearchResults() {
  return dispatch => {
    dispatch(getNextInfluencerPage());
    dispatch(getNextCollectivePage());
  };
}

export function getNextInfluencerPage() {
  return (dispatch, getState) => {
    dispatch(fetchInfluencers(
      {
        REQUEST: types.influencers.NEXT_PAGE_REQUEST,
        SUCCESS: types.influencers.NEXT_PAGE_SUCCESS,
        ERROR: types.influencers.NEXT_PAGE_ERROR,
      },
      getState().get('activeFilters'),
      getState().get('influencers').get('nextPage')
    ));
  };
}

export function getNextCollectivePage() {
  return (dispatch, getState) => {
    dispatch(fetchCollectives(
      {
        REQUEST: types.collectives.NEXT_PAGE_REQUEST,
        SUCCESS: types.collectives.NEXT_PAGE_SUCCESS,
        ERROR: types.collectives.NEXT_PAGE_ERROR,
      },
      getState().get('activeFilters'),
      getState().get('collectives').get('nextPage')
    ));
  };
}

export function getFilteredResults() {
  return (dispatch, getState) => {
    dispatch(fetchInfluencers(
      {
        REQUEST: types.influencers.FILTER_RESULTS_REQUEST,
        SUCCESS: types.influencers.FILTER_RESULTS_SUCCESS,
        ERROR: types.influencers.FILTER_RESULTS_ERROR,
      },
      getState().get('activeFilters'),
      1
    ));

    dispatch(fetchCollectives(
      {
        REQUEST: types.collectives.FILTER_RESULTS_REQUEST,
        SUCCESS: types.collectives.FILTER_RESULTS_SUCCESS,
        ERROR: types.collectives.FILTER_RESULTS_ERROR,
      },
      getState().get('activeFilters'),
      1
    ));
  };
}

export function fetchInfluencers(actionTypes = {}, queryParams = {}, page = 1) {
  // actionTypes required for each stage of request
  if (!actionTypes.REQUEST || !actionTypes.SUCCESS || !actionTypes.ERROR) return;

  const params = prepareParams(queryParams, page);

  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers${params}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        actionTypes.REQUEST,
        {
          type: actionTypes.SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        actionTypes.ERROR,
      ],
    },
  };
}

export function fetchCollectives(actionTypes = {}, queryParams = {}, page = 1) {
  // actionTypes required for each stage of request
  if (!actionTypes.REQUEST || !actionTypes.SUCCESS || !actionTypes.ERROR) return;

  const params = prepareParams(queryParams, page);

  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives${params}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        actionTypes.REQUEST,
        {
          type: actionTypes.SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        actionTypes.ERROR,
      ],
    },
  };
}

export function fetchInfluencer(id) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers/${id}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.INFLUENCER_REQUEST,
        {
          type: types.dataFetching.INFLUENCER_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.INFLUENCER_REQUEST_ERROR,
      ],
    },
  };
}

export function fetchCollective(id) {
  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives/${id}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.collectives.SINGLE_REQUEST,
        {
          type: types.collectives.SINGLE_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.collectives.SINGLE_ERROR,
      ],
    },
  };
}

function prepareParams(queryParams, page) {
  let snakeParams = decamelizeKeys(queryParams.toJS());
  let params = Object.keys(snakeParams).reduce((previous, key, index) => {
    if (snakeParams[key].length) {
      return previous + `&${key}=${snakeParams[key]}`;
    }

    return previous;
  }, '');

  if (page !== null && page !== undefined) {
    params += '&page=' + page;
  }

  return params.replace(/^&/, '?');
}

export function generateInfluencerReport(ids) {

  let params = 'influencerIds=' + ids;

  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/influencers/generate_report/?${params}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.GENERATE_INFLUENCER_REPORT_REQUEST,
        {
          type: types.dataFetching.GENERATE_INFLUENCER_REPORT_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.GENERATE_INFLUENCER_REPORT_REQUEST_ERROR,
      ],
    },
  };
}

export function generateCollectiveReport(ids) {

  let params = 'collectiveIds=' + ids;

  return {
    [CALL_API]: {
      endpoint: `${Config.apiEndpoint}/collectives/generate_report/?${params}`,
      method: 'GET',
      headers: requestHeaders,
      types: [
        types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST,
        {
          type: types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST_SUCCESS,
          payload: (action, state, res) => {
            const contentType = res.headers.get('Content-Type');
            if (contentType && ~contentType.indexOf('json')) {
              return res.json().then((json) =>  camelizeKeys(json));
            }
          },
        },
        types.dataFetching.GENERATE_COLLECTIVE_REPORT_REQUEST_ERROR,
      ],
    },
  };
}

// Schemas
const user = new Schema('users');



/** WEBPACK FOOTER **
 ** ./actions/api.js
 **/